/**
 * Display name per sidebar key, used for the section's accessible labels and the
 * placeholder copy in PatientShell.
 *
 * Note: Figma's section boards carry a "Section · NN / <title> / <blurb>" block
 * above them. That is an annotation naming the board — it is NOT part of the
 * screen, which starts at the navbar — so the number and blurb aren't kept here.
 */
const SECTION_META = {
  "ai-transcript": { name: "ECHO - AI transcript" },
  "patient-details": { name: "Patient details" },
  "progress-notes": { name: "Progress notes" },
  anthropometric: { name: "Anthropometric data" },
  "chief-complaints": { name: "Chief complaints" },
  diagnosis: { name: "Diagnosis" },
  medicines: { name: "Medicines" },
  "lab-investigations": { name: "Lab investigations" },
  allergies: { name: "Allergies" },
  "family-history": { name: "Family history" },
  hospitalisation: { name: "Hospitalisation history" },
  "drug-schedule": { name: "Drug schedule" },
  "food-preference": { name: "Food preferences" },
  "daily-schedule": { name: "Daily schedule" },
  "physical-activity": { name: "Physical activity" },
  addictions: { name: "Addictions" },
};

export default SECTION_META;
